export default function About() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              About <span className="text-green-600">Papi's Paving</span>
            </h2>
            <p className="text-base sm:text-lg text-gray-700 mb-6 leading-relaxed">
              With over 15 years of experience in the hardscape industry, Papi's Paving has become the trusted name for quality paving and outdoor construction services. We take pride in transforming ordinary outdoor spaces into extraordinary living areas that enhance your property's beauty and value.
            </p>
            <p className="text-base sm:text-lg text-gray-700 mb-8 leading-relaxed">
              Our team of skilled craftsmen combines traditional techniques with modern innovation to deliver exceptional results. From residential driveways to commercial patios, we approach every project with the same dedication to excellence and attention to detail that has made us a leader in hardscape construction.
            </p>
            
            <div className="grid grid-cols-3 gap-4 sm:gap-6">
              <div className="text-center">
                <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-purple-600 mb-2">15+</div>
                <div className="text-xs sm:text-sm text-gray-600">Years Experience</div>
              </div>
              <div className="text-center">
                <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-purple-600 mb-2">500+</div>
                <div className="text-xs sm:text-sm text-gray-600">Projects Completed</div>
              </div>
              <div className="text-center">
                <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-purple-600 mb-2">100%</div>
                <div className="text-xs sm:text-sm text-gray-600">Satisfaction Rate</div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="relative h-[400px] sm:h-[500px] rounded-lg overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/541fe7213a821aa250cfa4f0bfc4a7c2.jpg" 
                alt="Papi's Paving Team at Work" 
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-4 sm:-bottom-6 -left-4 sm:-left-6 bg-green-600 text-white p-4 sm:p-6 rounded-lg shadow-xl max-w-[200px] sm:max-w-none">
              <div className="flex items-center gap-2 sm:gap-3">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0">
                  <i className="ri-award-fill text-xl sm:text-2xl"></i>
                </div>
                <div>
                  <div className="font-bold text-sm sm:text-lg">Licensed &amp; Insured</div>
                  <div className="text-xs sm:text-sm text-white/90">Fully Certified</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
